export const MODALIDADES = {
  embalagem: {
    label: 'Paletiza\u00e7\u00e3o Embalagem',
    comprimentoMm: 2000,
    larguraMm: 1400,
    alturaPaleteMm: 145,
  },
  lojas_cem: {
    label: 'Paletiza\u00e7\u00e3o Lojas CEM',
    comprimentoMm: 2000,
    larguraMm: 1200,
    alturaPaleteMm: 130,
  },
};

export const parametrosModalidade = modalidade => MODALIDADES[modalidade] ?? MODALIDADES.embalagem;
